/**
* DO NOT EDIT THIS FILE.
* See the following change record for more information,
* https://www.drupal.org/node/2815083
* @preserve
**/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import ContentUtils from "./utils/content-utils.es6.js";
import ApiUtils from "./api-utils.es6.js";
var DESKTOP_BREAKPOINT = 1024;
var ENTER_CODE = 'Enter';
var SchedulingResults = function () {
  function SchedulingResults() {
    _classCallCheck(this, SchedulingResults);
    var inputFields = document.querySelector('.input-fields');
    document.querySelector('.icon--clear-conditions').addEventListener('click', SchedulingResults.disableSearchButton);
    if (window.innerWidth < DESKTOP_BREAKPOINT) {
      SchedulingResults.setMobileEvents();
      document.querySelector('.find-care-mobile').classList.add('find-care-mobile--disabled');
      inputFields.classList.add('input-fields--mobile');
    } else {
      document.querySelector('.find-care-desktop').classList.add('find-care-desktop--disabled');
      inputFields.classList.add('input-fields--desktop');
    }
  }
  return _createClass(SchedulingResults, null, [{
    key: "removeAllClasses",
    value: function removeAllClasses() {
      var inputFields = document.querySelector('.input-fields');
      inputFields.classList.remove('input-fields--overlay');
      inputFields.classList.remove('input-fields--search');
      inputFields.classList.remove('input-fields--mobile');
      inputFields.classList.remove('input-fields--desktop');
    }
  }, {
    key: "addMobileClass",
    value: function addMobileClass() {
      SchedulingResults.removeAllClasses();
      var inputFields = document.querySelector('.input-fields');
      inputFields.classList.add('input-fields--mobile');
    }
  }, {
    key: "addSearchClass",
    value: function addSearchClass() {
      SchedulingResults.removeAllClasses();
      var inputFields = document.querySelector('.input-fields');
      inputFields.classList.add('input-fields--search');
    }
  }, {
    key: "addOverlayClass",
    value: function addOverlayClass() {
      SchedulingResults.removeAllClasses();
      var inputFields = document.querySelector('.input-fields');
      var backgroundMask = document.querySelector('.background-mask');
      inputFields.classList.add('input-fields--overlay');
      backgroundMask.classList.add('background-mask--active');
    }
  }, {
    key: "removeOverlayClass",
    value: function removeOverlayClass() {
      SchedulingResults.addMobileClass();
      var backgroundMask = document.querySelector('.background-mask');
      backgroundMask.classList.remove('background-mask--active');
    }
  }, {
    key: "checkConditionClick",
    value: function checkConditionClick(e) {
      var conditionsInput = e.target.id === 'condition-search';
      var conditions = document.querySelector('.conditions--active');
      if (!conditions && e.target.nodeName !== 'LI' && !e.path.includes(document.getElementById('condition-clear'))) {
        SchedulingResults.addSearchClass();
      } else if (!conditionsInput && !conditions || e.target.nodeName === 'LI') {
        SchedulingResults.addOverlayClass();
      }
    }
  }, {
    key: "enableSearchButton",
    value: function enableSearchButton(e) {
      if (e.target.nodeName === 'LI' || e.target.nodeName === 'INPUT' || e.target.nodeName === 'BUTTON') {
        var findCareDesktopButton = document.querySelector('.find-care-desktop');
        var findCareMobileButton = document.querySelector('.find-care-mobile');
        findCareDesktopButton.classList.add('find-care-desktop--enabled');
        findCareDesktopButton.classList.remove('find-care-desktop--disabled');
        findCareDesktopButton.disabled = false;
        findCareMobileButton.classList.add('find-care-mobile--enabled');
        findCareMobileButton.classList.remove('find-care-mobile--disabled');
        findCareMobileButton.disabled = false;
      }
    }
  }, {
    key: "disableSearchButton",
    value: function disableSearchButton() {
      var findCareDesktopButton = document.querySelector('.find-care-desktop');
      var findCareMobileButton = document.querySelector('.find-care-mobile');
      findCareDesktopButton.disabled = true;
      findCareDesktopButton.classList.add('find-care-desktop--disabled');
      findCareDesktopButton.classList.remove('find-care-desktop--enabled');
      findCareMobileButton.disabled = true;
      findCareMobileButton.classList.add('find-care-mobile--disabled');
      findCareMobileButton.classList.remove('find-care-mobile--enabled');
    }
  }, {
    key: "checkLocationClick",
    value: function checkLocationClick(e) {
      var locations = e.currentTarget && e.currentTarget.classList.contains('location-search-container--active');
      if (locations) {
        SchedulingResults.addSearchClass();
      } else {
        SchedulingResults.addOverlayClass();
      }
    }
  }, {
    key: "setMobileEvents",
    value: function setMobileEvents() {
      var isSchedulingResultsPage = document.getElementById('scheduling-results');
      if (isSchedulingResultsPage) {
        var isMobile = window.innerWidth < DESKTOP_BREAKPOINT;
        var conditions = document.querySelector('.conditions__input-container');
        var conditionBack = document.getElementById('condition-back');
        var conditionCaretClose = document.getElementById('condition-caret-close');
        var closeModalIcon = document.getElementById('close-search-modal');
        var locations = document.querySelector('.location-search-container');
        var locationBack = document.getElementById('location-back');
        var mobileSearchBar = document.querySelector('.mobile-search-bar');
        if (isMobile) {
          SchedulingResults.setMobileClicks(closeModalIcon, conditions, conditionBack, conditionCaretClose, locations, locationBack, mobileSearchBar);
        } else {
          SchedulingResults.removeMobileClicks(closeModalIcon, conditions, conditionBack, conditionCaretClose, locations, locationBack, mobileSearchBar);
        }
      }
    }
  }, {
    key: "setMobileClicks",
    value: function setMobileClicks(closeModalIcon, conditions, conditionBack, conditionCaretClose, locations, locationBack, mobileSearchBar) {
      closeModalIcon.addEventListener('click', SchedulingResults.removeOverlayClass);
      conditions.addEventListener('click', SchedulingResults.checkConditionClick);
      conditionBack.addEventListener('click', SchedulingResults.addOverlayClass);
      conditionCaretClose.addEventListener('click', SchedulingResults.addOverlayClass);
      locations.addEventListener('click', SchedulingResults.checkLocationClick);
      locationBack.addEventListener('click', SchedulingResults.addOverlayClass);
      mobileSearchBar.addEventListener('click', SchedulingResults.addOverlayClass);
    }
  }, {
    key: "removeMobileClicks",
    value: function removeMobileClicks(closeModalIcon, conditions, conditionBack, conditionCaretClose, locations, locationBack, mobileSearchBar) {
      closeModalIcon.removeEventListener('click', SchedulingResults.removeOverlayClass);
      conditions.removeEventListener('click', SchedulingResults.checkConditionClick);
      conditionBack.removeEventListener('click', SchedulingResults.addOverlayClass);
      conditionCaretClose.removeEventListener('click', SchedulingResults.addOverlayClass);
      locations.removeEventListener('click', SchedulingResults.checkLocationClick);
      locationBack.removeEventListener('click', SchedulingResults.addOverlayClass);
      mobileSearchBar.removeEventListener('click', SchedulingResults.addOverlayClass);
    }
  }, {
    key: "setListeners",
    value: function setListeners() {
      window.addEventListener('resize', SchedulingResults.checkViewport);
      document.querySelector('#zip-code').addEventListener('input', function (e) {
        sessionStorage.removeItem('userCurrentLatLng');
        sessionStorage.removeItem('location');
        SchedulingResults.enableSearchButton(e);
      });
      document.querySelectorAll('.use-current-location').forEach(function (button) {
        button.addEventListener('click', function (e) {
          SchedulingResults.enableSearchButton(e);
        });
      });
    }
  }, {
    key: "addZipCodeClick",
    value: function addZipCodeClick() {
      window.addEventListener('load', SchedulingResults.setGoogleListener);
      SchedulingResults.setGoogleListener();
    }
  }, {
    key: "removeZipCodeClick",
    value: function removeZipCodeClick() {
      if (google && google.maps && google.maps.event && document.getElementsByClassName('pac-container')[0] && document.querySelector('.pac-target-input')) {
        if (google.maps.event.hasListeners(document.getElementsByClassName('pac-container')[0], 'mousedown') || google.maps.event.hasListeners(document.querySelector('.pac-target-input'), 'mousedown')) {
          window.removeEventListener('load', SchedulingResults.setGoogleListener);
          if (google && google.maps && google.maps.event) {
            google.maps.event.clearListeners(document.getElementsByClassName('pac-container')[0], 'mousedown');
            google.maps.event.clearListeners(document.querySelector('.pac-target-input'), 'mousedown');
          }
        }
      }
    }
  }, {
    key: "checkViewport",
    value: function checkViewport() {
      var inputFields = document.querySelector('.input-fields');
      if (window.innerWidth < DESKTOP_BREAKPOINT) {
        if (!document.querySelector('.input-fields--overlay')) {
          SchedulingResults.removeAllClasses();
          SchedulingResults.setMobileEvents();
          SchedulingResults.addZipCodeClick();
          inputFields.classList.add('input-fields--mobile');
        }
      } else {
        SchedulingResults.removeOverlayClass();
        SchedulingResults.removeAllClasses();
        SchedulingResults.setMobileEvents();
        SchedulingResults.removeZipCodeClick();
        inputFields.classList.add('input-fields--desktop');
      }
      document.querySelectorAll('.dropdown').forEach(function (dropdown) {
        dropdown.addEventListener('click', SchedulingResults.enableSearchButton);
        dropdown.addEventListener('keydown', function (event) {
          if (event.code === ENTER_CODE) {
            SchedulingResults.enableSearchButton(event);
          }
        });
      });
    }
  }, {
    key: "setGoogleListener",
    value: function setGoogleListener() {
      if (google && google.maps && google.maps.event && document.getElementsByClassName('pac-container')[0] && document.querySelector('.pac-target-input')) {
        google.maps.event.addDomListener(document.getElementsByClassName('pac-container')[0], 'mousedown', function (e) {
          for (var i = 0; i < e.target.parentElement.classList.length; i++) {
            if (e.target.parentElement.classList[i].indexOf('pac') > -1) {
              SchedulingResults.addOverlayClass();
              break;
            }
          }
        });
        google.maps.event.addDomListener(document.querySelector('.pac-target-input'), 'mousedown', function () {
          SchedulingResults.addSearchClass();
        });
      }
    }
  }, {
    key: "getPlaceholderData",
    value: function () {
      var _getPlaceholderData = _asyncToGenerator(_regeneratorRuntime().mark(function _callee2() {
        var dot, urlParams, initialCondition, recentCondition, hasReferral, locationFromSearch, referralText, mnemonic, setPlaceholderData, response, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              setPlaceholderData = function _setPlaceholderData(data) {
                var promises = data.included.map(function () {
                  var _ref = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(item) {
                    var locationPlaceholder, locationInput, mobileLocationPlaceholder, conditionPlaceholder, conditionsInput, mobileConditionPlaceholder;
                    return _regeneratorRuntime().wrap(function _callee$(_context) {
                      while (1) switch (_context.prev = _context.next) {
                        case 0:
                          if (!(item.type === 'paragraph--location_search')) {
                            _context.next = 7;
                            break;
                          }
                          locationPlaceholder = item.attributes.field_placeholder_copy;
                          locationInput = document.getElementById('zip-code');
                          mobileLocationPlaceholder = document.querySelector('.locations-placeholder');
                          if (locationFromSearch) {
                            mobileLocationPlaceholder.innerHTML = locationFromSearch;
                            locationInput.value = locationFromSearch;
                            mobileLocationPlaceholder.style.fontWeight = 'bold';
                          } else {
                            mobileLocationPlaceholder.innerHTML = locationPlaceholder;
                          }
                          _context.next = 25;
                          break;
                        case 7:
                          if (!(item.type === 'paragraph--conditions_search')) {
                            _context.next = 25;
                            break;
                          }
                          conditionPlaceholder = '';
                          conditionsInput = document.getElementById('condition-search');
                          mobileConditionPlaceholder = document.querySelector('.conditions-placeholder');
                          if (!initialCondition) {
                            _context.next = 17;
                            break;
                          }
                          conditionPlaceholder = "".concat(initialCondition, " ").concat(recentCondition).concat(referralText);
                          mobileConditionPlaceholder.style.fontWeight = 'bold';
                          conditionsInput.value = conditionPlaceholder;
                          _context.next = 24;
                          break;
                        case 17:
                          if (!mnemonic) {
                            _context.next = 23;
                            break;
                          }
                          _context.next = 20;
                          return ApiUtils.makeMnemonicHumanReadable(mnemonic);
                        case 20:
                          conditionsInput.value = _context.sent;
                          _context.next = 24;
                          break;
                        case 23:
                          conditionPlaceholder = item.attributes.field_placeholder_copy;
                        case 24:
                          mobileConditionPlaceholder.innerHTML = conditionPlaceholder;
                        case 25:
                        case "end":
                          return _context.stop();
                      }
                    }, _callee);
                  }));
                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());
                return Promise.all(promises);
              };
              dot = ContentUtils.decodeHtml('&#183');
              urlParams = new URLSearchParams(window.location.href.substring(window.location.href.indexOf('?')));
              initialCondition = sessionStorage.getItem('initial-condition');
              recentCondition = sessionStorage.getItem('recent-condition') ? "".concat(dot, " ").concat(sessionStorage.getItem('recent-condition')) : '';
              hasReferral = urlParams.get('hasReferral');
              locationFromSearch = sessionStorage.getItem('location');
              referralText = hasReferral ? ', I have a referral' : '';
              mnemonic = urlParams.get('mnemonic');
              _context2.prev = 9;
              _context2.next = 12;
              return fetch("/".concat(window.location.pathname.split('/')[1], "/jsonapi/node/scheduling_results?include=field_search_bar.field_location_search,field_search_bar.field_conditions_search"));
            case 12:
              response = _context2.sent;
              if (response.ok) {
                _context2.next = 15;
                break;
              }
              throw new Error("HTTP error! status: ".concat(response.status));
            case 15:
              _context2.next = 17;
              return response.json();
            case 17:
              data = _context2.sent;
              _context2.next = 20;
              return setPlaceholderData(data);
            case 20:
              _context2.next = 25;
              break;
            case 22:
              _context2.prev = 22;
              _context2.t0 = _context2["catch"](9);
              console.error(_context2.t0);
            case 25:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[9, 22]]);
      }));
      function getPlaceholderData() {
        return _getPlaceholderData.apply(this, arguments);
      }
      return getPlaceholderData;
    }()
  }]);
}();
export { SchedulingResults as default };
(function () {
  var isSchedulingResultsPage = document.getElementById('scheduling-results');
  if (isSchedulingResultsPage) {
    window.addEventListener('load', _asyncToGenerator(_regeneratorRuntime().mark(function _callee3() {
      var schedulingResults;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            schedulingResults = new SchedulingResults();
            SchedulingResults.checkViewport();
            SchedulingResults.getPlaceholderData();
            SchedulingResults.setListeners();
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })));
  }
})(Drupal);